export enum AcceptedFileType {
    Pdf = "pdf",
    Csv = "csv",
    Zip = "zip",
}
